//const avatarFolderPath = "../../content/images/avatars/";
const avatarLst = [
  '1.png',
  '2.png',
  '3.png',
  '4.png',
  '5.png',
  '6.png',
  '7.png',
  '8.png',
  '9.png',
  '10.png',
  '11.png',
  '12.png',
  '13.png',
  '14.png',
  '15.png',
  '16.png',
  '18.png',
  '19.png',
  '20.png',
  '21.png',
  '22.png',
  '23.png',
  '24.png',
  '26.png',
  '27.png',
  '28.png',
  '29.png',
  '30.png',
  '31.png',
  '32.png',
  '33.png',
  '34.png',
  '35.png',
  '36.png',
  '37.png',
  '38.png',
  '39.png',
  '40.png',
  '41.png',
  '42.png',
];

const airlines = [
  '1.png',
  '2.png',
  '3.png',
  '4.png',
  '5.png',
  '6.png',
  '7.png',
  '8.png',
  '9.png',
  '10.png',
];

// const avatarGifLst = [];
export const getRandomAvatar = () => {
  let randomNumber = Math.floor(Math.random() * avatarLst.length);
  return avatarLst[randomNumber];
};
export const returnAvatarList = () => {
  return avatarLst;
};
export const returnGifAvatarList = () => {
  return avatarGifLst;
};
export const getRandomGifAvatar = () => {
  let randomNumber = Math.floor(Math.random() * avatarGifLst.length);
  return avatarGifLst[randomNumber];
};
export const getRandomAirline = () => {
  let randomNumber = Math.floor(Math.random() * airlines.length);
  return airlines[randomNumber];
};
